import type { Product } from '../types/catalog';

export const REGULAR_PRICE = 59.99;
export const LAUNCH_PRICE = 49.99;

export const products: Product[] = [
  {
    id: 'eth-01',
    slug: 'versace-eros-flame',
    name: 'Versace Eros Flame',
    family: 'Ámbar',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Parfum',
    image:
      'https://cdn.magicpatterns.com/uploads/r4ckVEoVN8oes7C4ygQtpH/WhatsApp_Image_2026-08-25_at_12.04.42_PM.jpg',
    notes: {
      salida: ['Limón de Italia', 'Mandarina', 'Pimienta negra'],
      corazon: ['Pimienta rosa', 'Romero', 'Geranio'],
      fondo: ['Vainilla', 'Haba tonka', 'Madera de cedro'],
    },
    description:
      'Cítrico intenso que se calienta hasta volverse resina y vainilla. Presencia alta y estela larga, pensado para la noche.',
    ingredients: ['Limón italiano', 'Pimienta rosa', 'Vainilla', 'Haba tonka'],

  },
  {
    id: 'eth-02',
    slug: 'coco-mademoiselle',
    name: 'Coco Mademoiselle',
    family: 'Floral',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Parfum',
    image:
      'https://cdn.magicpatterns.com/uploads/sHvNQKWzrhJqZ6zD86QRic/WhatsApp_Image_2026-08-25_at_12.04.17_PM.jpg',
    notes: {
      salida: ['Naranja', 'Bergamota'],
      corazon: ['Rosa', 'Jazmín', 'Lichi'],
      fondo: ['Pachulí', 'Vetiver', 'Almizcle blanco'],
    },
    description:
      'Un floral oriental brillante y adictivo: cítricos chispeantes sobre un fondo de pachulí que se queda en la ropa.',
    ingredients: ['Naranja de Sicilia', 'Rosa de Mayo', 'Jazmín', 'Pachulí'],

  },
  {
    id: 'eth-03',
    slug: 'miss-dior-blooming-bouquet',
    name: 'Miss Dior Blooming Bouquet',
    family: 'Floral',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Toilette',
    image:
      'https://cdn.magicpatterns.com/uploads/6JhuDzaJVzxJ1FMgAGoQDF/WhatsApp_Image_2026-08-25_at_12.04.17_PM_(10).jpg',
    notes: {
      salida: ['Mandarina de Sicilia'],
      corazon: ['Peonía', 'Rosa de Damasco', 'Albaricoque'],
      fondo: ['Almizcle blanco'],
    },
    description:
      'Un ramo fresco y tierno de peonía y rosa sobre almizcle blanco. Ligero, luminoso y fácil de llevar todos los días.',
    ingredients: ['Mandarina de Sicilia', 'Peonía', 'Rosa de Damasco', 'Almizcle blanco'],

  },
  {
    id: 'eth-04',
    slug: 'bleu-de-chanel',
    name: 'Bleu de Chanel',
    family: 'Maderas',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Toilette',
    image:
      'https://cdn.magicpatterns.com/uploads/tWUkXULyocjqQLfcGeYrLS/WhatsApp_Image_2026-08-25_at_12.04.17_PM_(9).jpg',
    notes: {
      salida: ['Pomelo', 'Limón', 'Menta'],
      corazon: ['Jengibre', 'Nuez moscada', 'Jazmín'],
      fondo: ['Incienso', 'Vetiver', 'Cedro'],
    },
    description:
      'Amaderado aromático con apertura cítrica y fondo de incienso y cedro. Sobrio, versátil y de oficina a noche.',
    ingredients: ['Pomelo', 'Menta', 'Incienso', 'Cedro'],

  },
  {
    id: 'eth-05',
    slug: 'versace-eros',
    name: 'Versace Eros',
    family: 'Ámbar',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Parfum',
    image:
      'https://cdn.magicpatterns.com/uploads/9Zit3WaW3SUffkCva8Tikf/WhatsApp_Image_2026-08-25_at_12.04.17_PM_(8).jpg',
    notes: {
      salida: ['Menta', 'Manzana verde', 'Limón'],
      corazon: ['Haba tonka', 'Geranio', 'Ambroxan'],
      fondo: ['Vainilla', 'Cedro', 'Musgo de roble'],
    },
    description:
      'Menta fresca y manzana verde sobre un fondo dulce de vainilla y tonka. Un clásico moderno de proyección enorme.',
    ingredients: ['Menta', 'Manzana verde', 'Haba tonka', 'Vainilla'],

  },
  {
    id: 'eth-06',
    slug: 'polo-black',
    name: 'Polo Black',
    family: 'Maderas',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '125 ml',
    concentration: 'Eau de Toilette',
    image:
      'https://cdn.magicpatterns.com/uploads/hVR4hr7uuPwnDT3VgeB3Vd/WhatsApp_Image_2026-08-25_at_12.04.17_PM_(7).jpg',
    notes: {
      salida: ['Mango', 'Mandarina', 'Artemisa'],
      corazon: ['Salvia', 'Patchouli'],
      fondo: ['Madera de sándalo', 'Tonka'],
    },
    description:
      'Amaderado limpio y elegante con un toque frutal. Discreto de día y muy cómodo para uso diario.',
    ingredients: ['Mango', 'Artemisa', 'Sándalo', 'Tonka'],

  },
  {
    id: 'eth-07',
    slug: 'ysl-y',
    name: 'Yves Saint Laurent Y',
    family: 'Maderas',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Parfum',
    image:
      'https://cdn.magicpatterns.com/uploads/v5dHTqU7Y3CQ9ksAUza4LP/WhatsApp_Image_2026-08-25_at_12.04.17_PM_(5).jpg',
    notes: {
      salida: ['Bergamota', 'Jengibre'],
      corazon: ['Salvia', 'Geranio', 'Lavanda'],
      fondo: ['Haba tonka', 'Cedro', 'Ámbar gris'],
    },
    description:
      'Aromático amaderado de acabado limpio y contemporáneo. Fresco arriba, cálido y firme en el fondo.',
    ingredients: ['Bergamota', 'Salvia', 'Cedro', 'Haba tonka'],

  },
  {
    id: 'eth-08',
    slug: 'gucci-bloom-ambrosia-di-fiori',
    name: 'Gucci Bloom Ambrosia di Fiori',
    family: 'Floral',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Parfum Intense',
    image:
      'https://cdn.magicpatterns.com/uploads/h1gRCxHZFf6oinxuzi4fbE/WhatsApp_Image_2026-08-25_at_12.04.17_PM_(4).jpg',
    notes: {
      salida: ['Rosa de Damasco'],
      corazon: ['Nardo', 'Jazmín sambac'],
      fondo: ['Raíz de lirio', 'Almizcle'],
    },
    description:
      'Floral blanco denso y envolvente: nardo y jazmín en concentración intensa, con rosa para darle relieve.',
    ingredients: ['Rosa de Damasco', 'Nardo', 'Jazmín sambac', 'Raíz de lirio'],

  },
  {
    id: 'eth-09',
    slug: 'versace-eros-energy',
    name: 'Versace Eros Energy',
    family: 'Cítrica',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '100 ml',
    concentration: 'Eau de Parfum',
    image:
      'https://cdn.magicpatterns.com/uploads/f2Kdyo4nKJQoQunhixHGkh/WhatsApp_Image_2026-08-25_at_12.04.17_PM_(3).jpg',
    notes: {
      salida: ['Bergamota', 'Naranja sanguina', 'Menta'],
      corazon: ['Cardamomo', 'Jazmín'],
      fondo: ['Ambroxan', 'Cedro', 'Vainilla'],
    },
    description:
      'La versión más luminosa de Eros: cítricos brillantes y menta sobre un fondo ambarado limpio.',
    ingredients: ['Naranja sanguina', 'Menta', 'Cardamomo', 'Ambroxan'],

  },
  {
    id: 'eth-10',
    slug: 'good-girl-sparkling-ice',
    name: 'Good Girl Sparkling Ice',
    family: 'Ámbar',
    price: LAUNCH_PRICE,
    compareAtPrice: REGULAR_PRICE,
    size: '80 ml',
    concentration: 'Eau de Parfum',
    image:
      'https://cdn.magicpatterns.com/uploads/53uyXQH7cxtozaKpiHfDus/WhatsApp_Image_2026-08-25_at_12.04.16_PM.jpg',
    notes: {
      salida: ['Almendra', 'Café'],
      corazon: ['Nardo', 'Jazmín sambac'],
      fondo: ['Haba tonka', 'Cacao', 'Sándalo'],
    },
    description:
      'Almendra y café sobre flores blancas y cacao. Edición invernal, dulce y contrastada, con estela de horas.',
    ingredients: ['Almendra', 'Café', 'Nardo', 'Cacao'],

  },
];
